module.exports = __webpack_public_path__ + "static/media/loveprintnum.b94a36a8.svg";